<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">

    <!-- ================= TOOLBAR ================= -->
    <mat-toolbar [ngStyle]="eventId ? null : {'background-color': '#f2de30'}" [ngClass]="{'mat-primary': eventId}"
        class="example-toolbar">

        <!-- Menu Button -->
        <button mat-icon-button (click)="snav.toggle()">
            <mat-icon>menu</mat-icon>
        </button>

        <!-- Title -->
        <div class="toolbar-title">
            <span class="user-name">{{ User }}</span>
            <span class="event-name" *ngIf="Event_Name">• {{ Event_Name }}</span>
        </div>

        <span class="example-spacer"></span>

        <!-- ===== Desktop Actions ===== -->
        <div class="desktop-actions">

            <button class="me-2" *ngIf="User === 'superadmin' && eventId" mat-raised-button color="warn"
                (click)="Superadmin()" matTooltip="Back to Super Admin">
                <mat-icon>arrow_back</mat-icon>
                Super Admin
            </button>

            <button mat-icon-button matTooltip="Registration Form"
                *ngIf="User == 'admin' || User == 'subadmin' || (User == 'superadmin' && eventId)"
                (click)="Registration_Form()">
                <mat-icon>assignment</mat-icon>
            </button>

            <button mat-icon-button matTooltip="Copy Registration Link"
                *ngIf="User == 'admin' || User == 'subadmin' || (User === 'superadmin' && eventId)"
                (click)="copyLink()">
                <mat-icon>content_copy</mat-icon>
            </button>

            <button mat-icon-button matTooltip="QR Code"
                *ngIf="User == 'admin' || User == 'subadmin' || (User === 'superadmin' && eventId)"
                (click)="Registration_QR()">
                <mat-icon>qr_code</mat-icon>
            </button>

            <button mat-icon-button matTooltip="Change Event"
                *ngIf="User == 'admin' || User == 'subadmin' || User == 'stallowner' || User == 'so_event_owner' || User == 'user' || (User === 'superadmin' && eventId)"
                (click)="openDialog()">
                <mat-icon>swap_horiz</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="profileMenu">
                <mat-icon>person</mat-icon>
            </button>
        </div>

        <!-- ===== Mobile Actions ===== -->
        <button mat-icon-button class="mobile-actions" [matMenuTriggerFor]="mobileMenu">
            <mat-icon>more_vert</mat-icon>
        </button>

        <!-- Profile Menu -->
        <mat-menu #profileMenu="matMenu">
            <button mat-menu-item (click)="goToWebsite()">
                Back to Website <mat-icon>public</mat-icon>
            </button>
            <button mat-menu-item (click)="logout()">
                Logout <mat-icon>exit_to_app</mat-icon>
            </button>
        </mat-menu>

        <!-- Mobile Menu -->
        <mat-menu #mobileMenu="matMenu">
            <button mat-menu-item (click)="goToWebsite()">Back to Website</button>
            <button mat-menu-item (click)="Registration_Form()">Registration</button>
            <button mat-menu-item (click)="copyLink()">Copy Link</button>
            <button mat-menu-item (click)="Registration_QR()">QR Code</button>
            <button mat-menu-item (click)="openDialog()">Change Event</button>
            <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>

    </mat-toolbar>

    <!-- ================= SIDENAV ================= -->
    <mat-sidenav-container class="sidenav-container">

        <mat-sidenav #snav class="custom-sidenav" [mode]="mobileQuery.matches ? 'over' : 'side'"
            [opened]="!mobileQuery.matches" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">

            <div class="menu-container">
                <ng-container *ngFor="let menu of filteredMenus">

                    <!-- Menu with Children -->
                    <mat-accordion *ngIf="menu.children" class="menu-accordion">
                        <mat-expansion-panel class="custom-expansion-panel">
                            <mat-expansion-panel-header class="custom-expansion-header">
                                <mat-panel-title class="menu-title">
                                    <mat-icon class="menu-icon">{{ menu.icon || 'folder' }}</mat-icon>
                                    {{ menu.text }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="submenu-container">
                                <a *ngFor="let child of menu.children" class="submenu-link" [routerLink]="child.path"
                                    routerLinkActive="active-link" (click)="mobileQuery.matches && snav.toggle()">
                                    <mat-icon class="submenu-icon">{{ child.icon || 'chevron_right' }}</mat-icon>
                                    {{ child.text }}
                                </a>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <!-- Single Menu -->
                    <a *ngIf="!menu.children" class="menu-link" [routerLink]="menu.path" routerLinkActive="active-link"
                        (click)="mobileQuery.matches && snav.toggle()">
                        <mat-icon class="menu-icon">{{ menu.icon || 'dashboard' }}</mat-icon>
                        {{ menu.text }}
                    </a>

                </ng-container>
            </div>

        </mat-sidenav>

        <!-- ================= CONTENT ================= -->
        <mat-sidenav-content class="sidenav-content">
            <router-outlet></router-outlet>
        </mat-sidenav-content>

    </mat-sidenav-container>
</div>